module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "app-footer"
  }, [_c('a', {
    attrs: {
      "href": "https://enateinnova.com",
      "target": "_blank"
    }
  }, [_vm._v("SCE")]), _vm._v(" © 2019\n  "), _c('span', {
    staticClass: "float-right"
  }, [_vm._v("Developed by "), _c('a', {
    attrs: {
      "href": "https://enateinnova.com",
      "target": "_blank"
    }
  }, [_vm._v("ENATE Innova SL")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d60433b2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 569
// module chunks = 1